// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * NextWork API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { QuestionStatus } from './questionStatus';
import {
    QuestionStatusFromJSON,
    QuestionStatusFromJSONTyped,
    QuestionStatusToJSON,
    QuestionStatusToJSONTyped,
} from './questionStatus';
import type { MultipleChoiceOption } from './multipleChoiceOption';
import {
    MultipleChoiceOptionFromJSON,
    MultipleChoiceOptionFromJSONTyped,
    MultipleChoiceOptionToJSON,
    MultipleChoiceOptionToJSONTyped,
} from './multipleChoiceOption';
import type { QuestionDifficulty } from './questionDifficulty';
import {
    QuestionDifficultyFromJSON,
    QuestionDifficultyFromJSONTyped,
    QuestionDifficultyToJSON,
    QuestionDifficultyToJSONTyped,
} from './questionDifficulty';

/**
 * 
 * @export
 * @interface MultipleChoiceQuestion
 */
export interface MultipleChoiceQuestion {
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestion
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestion
     */
    type: MultipleChoiceQuestionTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof MultipleChoiceQuestion
     */
    question: string;
    /**
     * 
     * @type {Array<MultipleChoiceOption>}
     * @memberof MultipleChoiceQuestion
     */
    options: Array<MultipleChoiceOption>;
    /**
     * 
     * @type {QuestionDifficulty}
     * @memberof MultipleChoiceQuestion
     */
    difficulty: QuestionDifficulty;
    /**
     * 
     * @type {QuestionStatus}
     * @memberof MultipleChoiceQuestion
     */
    status: QuestionStatus;
}


/**
 * @export
 */
export const MultipleChoiceQuestionTypeEnum = {
    MultipleChoice: 'multiple-choice'
} as const;
export type MultipleChoiceQuestionTypeEnum = typeof MultipleChoiceQuestionTypeEnum[keyof typeof MultipleChoiceQuestionTypeEnum];


/**
 * Check if a given object implements the MultipleChoiceQuestion interface.
 */
export function instanceOfMultipleChoiceQuestion(value: object): value is MultipleChoiceQuestion {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('question' in value) || value['question'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    if (!('difficulty' in value) || value['difficulty'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function MultipleChoiceQuestionFromJSON(json: any): MultipleChoiceQuestion {
    return MultipleChoiceQuestionFromJSONTyped(json, false);
}

export function MultipleChoiceQuestionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MultipleChoiceQuestion {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'type': json['type'],
        'question': json['question'],
        'options': ((json['options'] as Array<any>).map(MultipleChoiceOptionFromJSON)),
        'difficulty': QuestionDifficultyFromJSON(json['difficulty']),
        'status': QuestionStatusFromJSON(json['status']),
    };
}

export function MultipleChoiceQuestionToJSON(json: any): MultipleChoiceQuestion {
    return MultipleChoiceQuestionToJSONTyped(json, false);
}

export function MultipleChoiceQuestionToJSONTyped(value?: MultipleChoiceQuestion | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'question': value['question'],
        'options': ((value['options'] as Array<any>).map(MultipleChoiceOptionToJSON)),
        'difficulty': QuestionDifficultyToJSON(value['difficulty']),
        'status': QuestionStatusToJSON(value['status']),
    };
}

